import { AsyncPipe } from '@angular/common';
import { Component, Input, ViewContainerRef } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MomentModule } from 'ngx-moment';
import { iif, of, Subject } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { CustomerEquipment } from '../../../models/customer-equipment';
import { AddCustomerEquipmentDialogComponent } from '../../../shared/dialogs/add-customer-equipment-dialog/add-customer-equipment-dialog.component';
import { WorkshopJobHistoryComponent } from '../../../shared/dialogs/workshop-job-history/workshop-job-history.component';
import { ConfigService } from '../../../shared/services/config.service';
import { CustomerEquipmentService } from '../../../shared/services/customer-equipment.service';

@Component({
  selector: 'app-customer-equipment',
  templateUrl: './customer-equipment.component.html',
  providers: [CustomerEquipmentService],
  standalone: true,
  imports: [MatTableModule, MomentModule, AsyncPipe, MatButton]
})
export class CustomerEquipmentComponent {
  columns = ['name', 'created_at', 'serial_number', 'actions'];

  @Input() set customerId(id: number) {
    this._customerId = id;
    this.customerId$.next(id);
  }

  private _customerId: number;
  private customerId$ = new Subject<number>();
  dateFormat = ConfigService.dates.dateFormat;
  rows$ = this.customerId$.pipe(
    mergeMap((id) =>
      iif(() => Boolean(id), this.customerEquipmentService.getAll(id), of([]))
    ),
    tap((rows) => {
      console.log(rows);
    })
  );

  constructor(
    private customerEquipmentService: CustomerEquipmentService,
    private dialog: MatDialog,
    private vcr: ViewContainerRef
  ) {}

  addEquipment() {
    this.dialog
      .open(AddCustomerEquipmentDialogComponent, {
        data: { customerId: this._customerId },
        viewContainerRef: this.vcr
      })
      .afterClosed()
      .subscribe((equipment) => {
        if (equipment) {
          this.customerId$.next(this._customerId);
        }
      });
  }

  openEquipmentServiceHistory(equipment: CustomerEquipment) {
    this.dialog.open(WorkshopJobHistoryComponent, {
      data: {
        repairable: equipment,
        type: 'customerEquipment',
        id: equipment.id
      },
      viewContainerRef: this.vcr
    });
  }
}
